import { ApiServiceV1 } from '@services/api.service';

export const MachineCategoriesApiService = {
  async getMachineCategories({ suffix }) {
    const { data } = await ApiServiceV1.get(`${suffix}/machine-categories`);

    return data || [];
  },

  async createMachineCategory({ suffix, name }) {
    await ApiServiceV1.post(`${suffix}/machine-categories`, { name });
  },

  async updateMachineCategory({ suffix, oldName, name }) {
    await ApiServiceV1.post(`${suffix}/machine-categories/${oldName}`, { name });
  },
};
